import { ADDITIONAL_ROLES, USER_ROLE } from 'src/app/@core/models/enums';
import { IUser } from 'src/app/@core/models/model';

/**
 * Whether a user may view and act on billing surfaces — the Billing & Invoices
 * page, the plan tag, and credit allocation in Credits usage.
 *
 * BILLING_ADMIN lives in `additionalRoles` and is orthogonal to the primary role,
 * so a MEMBER can hold it. The account owner (SUPER_ADMIN) always has billing
 * access: they receive BILLING_ADMIN implicitly at signup, but the role can later
 * be transferred away, and they must not lose access when it is.
 *
 * Takes the user as an argument rather than reading the auth service, because
 * callers source it differently — most decode the JWT, while the people page
 * refreshes it from the server, and one call site tests a *different* user.
 *
 * @param user - The user to test; null/undefined yields false.
 */
export function hasBillingAccess(user?: IUser | null): boolean {
    if (!user) return false;
    return user.role === USER_ROLE.SUPER_ADMIN
        || (user.additionalRoles?.includes(ADDITIONAL_ROLES.BILLING_ADMIN) ?? false);
}
